import _ from '@/common/helpers/index';
import utils from '../utils';
import {RBadge} from '@rebilly/recomponents';

/**
 * Creates a `router-link` component to link within the app.
 * @param {CachedColumn} cachedColumn
 * @param {Object} rowData
 * @param {Function} createElement
 * @returns {string}
 */

function getBadgeColor(cachedColumn, value) {
    let color = '';
    if (cachedColumn.props.map && value in cachedColumn.props.map) {
        color = `${cachedColumn.props.map[value]}`;
    }
    return color || 'default';
}

export default function badgeColumn({cachedColumn, rowData, createElement}) {
    const badges = utils.getCellValues({cachedColumn, rowData});
    let children;
    if (badges.length) {
        // reduce values into an array of badge elements
        const reducer = (reduced, value) => reduced.concat(createElement(
            RBadge,
            {
                props: {
                    type: getBadgeColor(cachedColumn, value),
                },
                attrs: {title: value},
            },
            _.unKebabCase(value),
        ));
        children = utils.separateChildren({
            values: badges.reduce(reducer, []),
            createElement,
            delimiter: ' ',
        });
    } else {
        // render an empty cell element
        children = [utils.getEmptyCellElement(createElement)];
    }

    return [
        'div',
        children,
    ];
}
